import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import '../styles/Emailform.css';
import { useTranslations } from '../hooks/useTranslations';

function EmailForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const [messageSent, setMessageSent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslations();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const apiUrl = process.env.REACT_APP_API_URL_EMAIL;

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!apiUrl) {
      console.error('Email API URL is not configured');
      setIsSubmitting(false);
      return;
    }

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setMessageSent(true);
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: '',
        });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsSubmitting(false); // Reset loading state
      });
  };

  useEffect(() => {
    if (messageSent) {
      const timer = setTimeout(() => {
        setMessageSent(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [messageSent]);

  return (
    <div className='screen'>
    <div className='contact-container'>
      <div className='ota-yhteyttä'>
        <div className='contact-video-background'>
          <video
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            aria-label={t('contact.videoAriaLabel', 'Ota yhteyttä video')}
            onError={(e) => {
              console.error('Video loading error:', e);
              console.error('Video source:', e.target.currentSrc);
              console.error('Video error code:', e.target.error?.code);
            }}
            onLoadedData={() => {
              console.log('Video loaded successfully');
            }}
            onCanPlay={() => {
              console.log('Video can play');
            }}
          >
            <source src="/Contact us video.mp4" type="video/mp4" />
            <source src="Contact us video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className='contact-video-overlay'></div>
        </div>
        <div className='contact-content'>
        <h1>{t('contact.heading', 'Ota yhteyttä')}</h1>
        <form onSubmit={handleSubmit}>
          <div className='inputs'>
            <input
              type="text"
              name="name"
              placeholder={t('contact.form.placeholders.name', 'Nimi*')}
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className='inputs'>
            <input
              type="email"
              name="email"
              placeholder={t('contact.form.placeholders.email', 'Sähköposti*')}
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className='inputs'>
            <input
              type="text"
              name="phone"
              placeholder={t('contact.form.placeholders.phone', 'Puhelin')}
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
          <div className='inputs'>
            <input
              type="text"
              name="subject"
              placeholder={t('contact.form.placeholders.subject', 'Otsikko*')}
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>
          <div className='inputs'>
            <textarea
              name="message"
              placeholder={t('contact.form.placeholders.message', 'Viesti*')}
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <button className='button-lähetä' type="submit" disabled={isSubmitting}>
              {isSubmitting
                ? t('contact.form.buttons.sending', 'Lähetetään...')
                : t('contact.form.buttons.submit', 'Lähetä')}
            </button>
            {messageSent && !isSubmitting && (
              <div className="message-sent" style={{ marginTop: '35px', marginLeft: '14px' }}>
                {t('contact.form.status.success', '✓ Viesti lähetetty!')}
              </div>
            )}
          </div>
        </form>
        </div>
      </div>
    </div>
    </div>
  );
}

export default EmailForm;
